import React, { useState,useEffect } from 'react';
import { Row,Col, Card, Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import "easymde/dist/easymde.min.css";

import { GetCampaignsListAction,GetTagGeneratorAction,GetEditTagDataAction,DeleteTagCampaign,ClearAddNewCampaignResponse } from '../../Redux/Actions/TagGeneratorAction';

import TopFilter from './components/TopFilter';
import { IReduxState } from "../../utils/types";
import ListingComponent from './components/ListingComponent';
import TagData from './components/TagData';
import AddEditTagForm from './components/AddEditTagForm';

const YallaView =()=>{
  const [activeScreen,setActiveScreen] = useState(1);
  const [campaignList, setCampaignList] = useState<Array<any>>([]); //USED FOR TABLE DATA
  const [editTagData, setEditTagData] = useState(false); //EDIT TAG 

  const [dsp,setDsp] = useState('DSP'); //USED FOR TOP FILTER
  const [type,setType] = useState('Type'); //USED FOR TOP FILTER
  const [env,setEnv] = useState('Environment'); //USED FOR TOP FILTER
  const [exchange,setExchange] = useState('Exchange'); //USED FOR TOP FILTER 
  const [addOns,setAddOns] = useState('Add-Ons');

  const [showErrorModal, setShowErrorModal] = useState(false); //Table Actions
  const [deletingTag, setDeletingTag] = useState({ id: "", name: "" }); //DELETE TAG DATA

  const [showingTagName, setShowingTagName] = useState(""); // Tag Section State.

  const tagGeneratorState = useSelector((state: IReduxState) => state.TagGenerator );

  const dispatch = useDispatch();

  const handleNewTagBtnClick =()=>{
      setActiveScreen(2);
      setCampaignList([]); 
  }

  useEffect(() => {
    dispatch(GetCampaignsListAction({ dsp: "DSP", type: "Type" /*, env: "Environment",*/ , exchange: "Exchange", addOns:"Add-Ons"}));
  }, [dispatch]);

  useEffect(() => {
    dispatch(GetCampaignsListAction({ dsp: dsp, type: type/*,env: env*/  ,exchange: exchange, addOns: addOns}));
  }, [dispatch,dsp,type,exchange,addOns/*,env*/]);

  useEffect(() => {
    setCampaignList(tagGeneratorState?.campaignList);
  }, [tagGeneratorState?.campaignList]);
  

  const showTagHandler = (name: string) => {
    dispatch(GetTagGeneratorAction(name));
    setShowingTagName(name);
  };

  const editTagHandler = (name: string) => {
    if (name !== "") {
      dispatch(GetEditTagDataAction(name));
    }
  };

  const showDeleteModal = (obj: any) => {
    setShowErrorModal(true);
    setDeletingTag({ name: obj.name, id: obj._id });
  };

  const deleteTagHandler = () => {
    dispatch(DeleteTagCampaign(deletingTag.id));
    setShowErrorModal(false);
    setDeletingTag({ id: "", name: "" });
    dispatch(GetCampaignsListAction({ dsp: dsp, type: type, exchange: exchange, addOns:addOns /*, env: env*/ }));
  };

  const handleTagDataCancel=()=>{
    setShowingTagName("");
    dispatch(GetCampaignsListAction({ dsp: dsp, type: type, exchange: exchange, addOns:addOns /*, env: env*/ }));
  }

  /***-------Handle Add-Edit Success and redirection to screen 1 -----*/
  useEffect(() => {
    if (tagGeneratorState?.redirect) {
      setActiveScreen(1);
      setEditTagData(false); 
      refreshList();
    } 
    return () => {
      dispatch(ClearAddNewCampaignResponse());
    };
  }, [tagGeneratorState?.redirect, dispatch]);

  /***-------Handle Setup Edit Data and redirection to screen 2 -----*/
  useEffect(() => {
    if (tagGeneratorState?.success) {
      setActiveScreen(2); 
      setEditTagData(true);
    } 
    return () => {
      dispatch(ClearAddNewCampaignResponse());
    };
  }, [tagGeneratorState?.success, dispatch]);

  const refreshList =()=>{
    dispatch(GetCampaignsListAction({ dsp: dsp, type: type, exchange: exchange, addOns:addOns /*, env: env*/ }));
  }

  return (
    <>
      <Row className="d-flex justify-content-center mt-3">
        <Row><h3 className="module_title">TAG GENERATOR</h3></Row>
        <Col lg={12}>
          <Card> 
              {activeScreen === 1 && tagGeneratorState?.tagData === "" && <TopFilter handleNewTagBtnClick={handleNewTagBtnClick} setDsp={setDsp} setType={setType} setEnv={setEnv} setExchange={setExchange} setAddOns={setAddOns} dsp={dsp} type={type} env={env} exchange={exchange} addOns={addOns} />} 
              <Card.Body>
                  {activeScreen === 1 && tagGeneratorState?.tagData === "" && 
                    <>
                      <ListingComponent campaignList={campaignList} showTagHandler={showTagHandler} editTagHandler={editTagHandler} showDeleteModal={showDeleteModal}/>
                      <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)} centered >
                        <Modal.Header onHide={() => setShowErrorModal(false)} closeButton ></Modal.Header>
                        <Modal.Body className="text-center">
                          <i className="uil-no-entry text-warning display-3"></i>
                          <h4 className="text-danger mt-4"> Delete {deletingTag.name}</h4>
                          <p className="w-75 mx-auto text-muted"> Are you sure you want to delete this tag?{" "}</p>
                          <div className="mt-4">
                            <Button onClick={() => { setShowErrorModal(false); }} variant="light">
                              Cancel
                            </Button>
                            <Button onClick={() => { deleteTagHandler(); refreshList();}} variant="primary" >
                              Delete Tag
                            </Button>
                          </div>
                        </Modal.Body>
                      </Modal>
                    </>
                  }
                  {activeScreen === 1 && tagGeneratorState?.tagData !== "" && <TagData showingTagName={showingTagName} tagData={tagGeneratorState?.tagData}  handleTagDataCancel={handleTagDataCancel} />  } 
                  {activeScreen === 2 && <AddEditTagForm editTagData={editTagData} setEditTagData={setEditTagData} setActiveScreen={setActiveScreen} dispatch={dispatch} refreshList={refreshList} />  }
              </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default YallaView;